<template>
  <!-- 客户信息（上部）详情卡片 -->
  <div class="detailCard">
    <div class="card-header">
      <!-- 标题 -->
      <div class="title">
        {{title}}
      </div>
      <!-- （配置可选 btn-name）右上角的编辑按钮 -->
      <div class="btn">
        <!-- <el-button @click="btnClick">{{btnName}}</el-button> -->
      </div>
    </div>
    <div class="card-main">
      <div class="card-item">
          <span>客户全称：</span>
          <span>{{detailInfo.client_fullname}}</span>
      </div>
      <div class="card-item">
        <span>客户行业：</span>
        <span>{{detailInfo.license}}</span>
      </div>
      <div class="card-item">
        <span>所属地区：</span>
        <span>{{detailInfo.client_region}}</span>
      </div>
      <div class="card-item">
        <span>公司结构：</span>
        <span><el-link type="primary" @click="browseBigPicture">{{'查看大图'}}</el-link></span>
      </div>
      <div class="card-item">
        <span>销售组：</span>
        <span>{{detailInfo.secondary_dept}}</span>
      </div>
      <div class="card-item">
        <span>客户经理：</span>
        <span>{{detailInfo.account_manager_name}}</span>
      </div>
    </div>
    <ClientEdit v-model="clientEditDialogVisible" :clientInfoDetailFormat="clientInfoDetailFormat" @refresh="refresh" />
  </div>


</template>

<script>
import ClientEdit from "@/component/Client/ClientDetail/Card/ClientEdit";
import {getClientBaseInfo} from "@/api/api";
export default {
  name: "ClientDetailCard",
  components: {
    ClientEdit
  },
  props:{
    title:{
      required:true
    },
    // 如果传入btnName就会右上角有一个按钮
    btnName:{
      type:String,
      default:'编辑'
    },
    clientName:{
      type:String,
      required:true
    }
  },
  data(){
    return {
      detailInfo:null,
      clientEditDialogVisible: false,
      clientInfoDetailFormat:null
    }
  },
  async mounted() {
    this.refresh()
  },
  methods:{
    // 编辑客户信息
    btnClick(){
      // alert('编辑客户信息')
      this.clientInfoDetailFormat = Object.assign(JSON.parse(JSON.stringify(this.detailInfo)),{client_name:this.clientName})
      this.clientEditDialogVisible = true
    },
    // 查看大图
    browseBigPicture(){
      alert('暂无')
    },

    async refresh(refresh=false) {
      await this.getData()
      if(refresh){
        this.$emit('refresh', 'clientEdit')
      }
    },

    async getData() {
      const {respData} =  await getClientBaseInfo({"client_name":this.clientName})
      this.detailInfo = respData[0]
      // this.$emit('getAccountManager', this.detailInfo.account_manager_name)
      this.$emit('getClientInfo', this.detailInfo)
    }

  }
}
</script>

<style scoped>
  .detailCard{
    /* width: 55%; */
    width: 100%;
    padding: 30px;
    box-shadow:0 2px 12px 0 rgb(0 0 0 / 10%);
  }
  .title{
    font-weight: bold;
    font-size:18px
  }
  .card-header{
    display: flex;
    justify-content: space-between;
  }
  .card-item > span:first-child{
    display: inline-block;
    min-width: 100px;
  }
  .card-item{
    padding-top: 10px;
    font-size: 14px;
  }
</style>